module.exports = __webpack_public_path__ + "img/thumbs-up-solid.c31074bc.svg";